import GTM from '../datalayer';
import gtmUtils from '../utils';

const variationDataConditional = (variationID, allvarType, value) => {
    let selectedVariation = false;

    if ((variationID)) {
        if (allvarType[variationID].toString() === value.toString()) {
            selectedVariation = true;
        }
    }

    return selectedVariation;
};

const getVariationValues = (data, allvarType) => {
    const variationID = data.attributeId;

    return data.values.map(d => ({
        selected: variationDataConditional(variationID, allvarType, d.value),
        value: d.value,
    }));
};

// get current selected attr values
const getSelectedVariations = (variationData, product) => {
    const allSelectedvariationsType = {};
    const allAttrSelectors = product.find('.attribute > .attributeLink.isactive, .attribute > .swatchable > span.selected');

    allAttrSelectors.each((indx, val) => {
        const elem = $(val);
        allSelectedvariationsType[elem.parents('.swatch').data('attr')] = elem.data('attr-value');
    });

    const variationsArr = variationData.map(data => ({
        attributeId: data.attributeId,
        values: getVariationValues(data, allSelectedvariationsType),
    }));

    return gtmUtils.filterVariations(variationsArr);
};

const validateElement = element => (element === null ? '' : element);

const getDatalayerStructure = (element, item) => {
    const prodObj = {
        price: validateElement(element
            .find('.gtmProdPrice')
            .data('pinfo'))
            .toString(),
        name: element.find('.pdp-link > a')[0].innerText,
        id: validateElement(element.data('pid')).toString(),
        brand: validateElement(element.find('.gtmProdBrand').data('pinfo')),
        category: validateElement(element.find('.gtmProdCategory').data('pinfo')),
        list: gtmUtils.getList(element),
        position: item + 1,
    };

    return prodObj;
};

const getAndPushProductImpressions = () => {
    const $product = $('.product');
    const $carousel = $('.featured-carousel-container');

    if ($product.length) {
        const products = [];

        $product.each((item, value) => {
            const element = $(value);

            if (element.find('.banner-product').length <= 0) {
                products.push(getDatalayerStructure(element, item));
            }
        });

        GTM.trackProductImpression({
            currency: $('.product').find('.price > span > meta').length
                ? $('.product').find('.price > span > meta')[0].content
                : $('.gtmCurrencyPrice').data('pinfo'),
            product: products,
        });

        $carousel.off('DOMSubtreeModified');
    }

    if ($carousel.length && !$product.length) {
        $carousel.on('DOMSubtreeModified', () => {
            $('body').trigger('datalayer:updateGrid');
        });
    }

    if ($carousel.length && !$product.length) {
        $carousel.on('DOMSubtreeModified', () => {
            $('body').trigger('datalayer:updateGrid');
        });
    }
};

const productQuickViewClicked = () => {
    const product = [];

    if ($('a.quickview').length) {
        $('body').on('click', 'a.quickview', (e) => {
            e.preventDefault();
            const productDiv = $($(e.currentTarget).parents('.product'));

            product.push(gtmUtils.productClickStructure(productDiv));

            GTM.trackQuickViewClickProduct('productQuickViewClick', {
                product,
                category: gtmUtils.getList(productDiv),
            });
        });
    }
};

const productClicked = () => {
    const product = [];

    if ($('.product-tile').length) {
        $('body').on(
            'click',
            '.product-tile > .image-container > a:not(.wishlistTile):not(.quickview), .product-tile > .tile-body > .pdp-link > a.product-name',
            (e) => {
                e.preventDefault();
                const productDiv = $($(e.currentTarget).parents('.product'));
                const productUrl = productDiv.find('.pdp-link > a')[0].href;

                product.push(gtmUtils.productClickStructure(productDiv));

                GTM.trackClickedProduct('productClick', {
                    product,
                    list: gtmUtils.getList(productDiv),
                    productUrl,
                });

                window.location.href = productUrl;
            },
        );
    }
};

const getDatalaAddToCartStructure = (productToAdd) => {
    const gtmProdVariations = JSON.parse(productToAdd
        .find('.gtmProdVariations')
        .attr('data-pinfo'));

    const objStructure = {
        product: {
            name: productToAdd.find('.pdp-link > a')[0].innerText,
            id: validateElement(productToAdd.data('pid')),
            price: validateElement(productToAdd
                .find('.gtmProdPrice')
                .data('pinfo'))
                .toString(),
            brand: validateElement(productToAdd.find('.gtmProdBrand').data('pinfo')),
            category: validateElement(productToAdd.find('.gtmProdCategory').data('pinfo')),
            variant: gtmProdVariations.length
                ? getSelectedVariations(gtmProdVariations, productToAdd)
                : '',
            quantity: productToAdd.find('.quantity-form .quantity').val(),
        },
        currencyCode: validateElement(productToAdd
            .find('.gtmCurrencyPrice')
            .data('pinfo')),
    };

    objStructure.product.sku = validateElement(productToAdd.find('.gtmSkuVariation').data('pinfo'));

    return objStructure;
};

const infoAddToCart = () => {
    $('body').on(
        'click',
        'button.add-to-cart-globalGrid',
        (e) => {
            const target = $(e.target);

            if (!target.hasClass('disabled')) {
                const productToAdd = target.parents('.product');
                GTM.trackAddProductToCart(
                    getDatalaAddToCartStructure(productToAdd),
                    gtmUtils.getList(productToAdd),
                );
            }
        },
    );
};

const updateGridProductsData = () => $('body').on('datalayer:updateGrid', () => getAndPushProductImpressions());

export default () => {
    getAndPushProductImpressions();
    productQuickViewClicked();
    productClicked();
    infoAddToCart();
    updateGridProductsData();
};
